import { useMemo, useState } from "react";
import { DrugsTable } from "pages/patient/PatientMedicationPage/components/DrugsTable/DrugsTable";

import { useDataTableSelection } from "components/ui/DataTable/hooks/useDataTableSelection";
import { usePaginatedLongTermMedications } from "features/medications/hooks/usePaginatedLongTermMedications";
import { useStopMedication } from "features/medications/hooks/useStopMedication";

import s from "./MedicationReviewPanel.module.css";

// Medication review for a CDM/PP/OCF review — long-term medications only, rendered
// as the bare table (no "Add medication" actions, no title) for review context.
// Presentation-agnostic: render inside an Accordion, a Modal, or anywhere patientId is known.
export const MedicationReviewPanel = ({ patientId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState("All");
  const selection = useDataTableSelection();
  const { stopMedication } = useStopMedication();

  const { data, isLoading, isError, refetch } = usePaginatedLongTermMedications(
    patientId,
    currentPage,
    searchQuery,
    rows === "All" ? 9999 : rows
  );

  const medications = useMemo(() => [...(data?.data || [])], [data]);
  const totalRecords = data?.totalRecords ?? 0;

  return (
    <div className={s.panel} data-testid="medication-review-panel">
      <DrugsTable
        items={medications}
        isLoading={isLoading}
        isError={isError}
        errorLabel="this patient's long term medications"
        onRetry={refetch}
        emptyTitle="No Long term prescriptions"
        selection={selection}
        deleteDrug={stopMedication}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        totalRecords={totalRecords}
        rows={rows}
        setRows={setRows}
        tradeNameWidth="440px"
      />
    </div>
  );
};
